import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Footer from "./Footer";
import Navbar from "./Navbar";
// import BankGradeCard from "./BankGradeCard";
import WhyChooseUs from "./WhyChooseUs";
import SEO from "./SEO";

// Modular Components
import Hero from "./home/Hero";
import PriorityStatus from "./home/PriorityStatus";
import Process from "./home/Process";
import About from "./home/About";
import Services from "./home/Services";
import Partners from "./home/Partners";


gsap.registerPlugin(ScrollTrigger);

function CompanyLanding() {
  const heroRef = useRef<HTMLElement>(null);
  const sectionsRef = useRef<(HTMLElement | null)[]>([]);

  const companyName = import.meta.env.VITE_COMPANY_NAME || "the Company";

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: "power4.out" } });

      tl.from(".terminal-header-line", {
        scaleX: 0,
        duration: 1.5,
        transformOrigin: "left"
      })
        .from(".hero-headline", {
          y: 100,
          opacity: 0,
          duration: 1.2,
          skewY: 7,
        }, "-=0.5")
        .from(".hero-subtext", {
          y: 30,
          opacity: 0,
          duration: 1,
        }, "-=0.8")
        .from(".cta-terminal", {
          y: 30,
          opacity: 0,
          duration: 1,
          stagger: 0.2,
        }, "-=0.6");

      // Horizontal Scanning Line Animation
      gsap.to(".scanning-line", {
        top: "100%",
        duration: 4,
        repeat: -1,
        ease: "none"
      });

      // Section Reveals
      sectionsRef.current.forEach((section) => {
        if (section) {
          gsap.from(section, {
            y: 50,
            opacity: 0,
            duration: 1,
            scrollTrigger: {
              trigger: section,
              start: "top 85%",
            }
          });
        }
      });
    }, heroRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="min-h-screen w-full bg-white text-text-primary px-0 mx-0 overflow-x-hidden font-sans selection:bg-primary-light selection:text-primary">
      <SEO
        title="Home"
        description={`Welcome to ${companyName}. A Registered NBFC dedicated to providing accessible financial solutions.`}
        keywords={`personal loan India, NBFC, ${companyName}, business loans`}
      />

      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden bg-gradient-to-b from-white via-blue-50/50 to-white" />

      <div className="relative z-10 flex w-full flex-col">
        <Navbar />

        <Hero heroRef={heroRef} companyName={companyName} />

        <Process
          sectionRef={(el) => { sectionsRef.current[3] = el; }}
        />

        <PriorityStatus />

        <About
          sectionRef={(el) => { sectionsRef.current[0] = el; }}
          companyName={companyName}
        />

        <Services
          sectionRef={(el) => { sectionsRef.current[1] = el; }}
        />

        <WhyChooseUs />

        <Partners
          sectionRef={(el) => { sectionsRef.current[2] = el; }}
        />


        <Footer />
      </div>
    </div>
  );
}

export default CompanyLanding;
